import type { Dispatch as ReduxDispatch } from '@reduxjs/toolkit';

import type { Vimeo } from '../@types/Vimeo';
import type { BaseAction } from '../@types/actions';
import * as http from '../Http';
import { buildGetRequest } from '../Http/requestTemplates';
import requestCache from '../utils/request-cache';

export const REQ_VIMEO_THUMBNAIL = 'REQ/VIMEO_THUMBNAIL';
export const RCV_VIMEO_THUMBNAIL = 'RCV/VIMEO_THUMBNAIL';
type REQ_VIMEO_THUMBNAIL_TYPE = BaseAction<typeof REQ_VIMEO_THUMBNAIL> & {
  id: string;
};
type RCV_VIMEO_THUMBNAIL_TYPE = BaseAction<typeof RCV_VIMEO_THUMBNAIL> & {
  response: Vimeo;
  id: string;
};

export const REQ_FAILED = 'REQ/FAILED_VIMEO';
type REQUEST_FAILED_TYPE = BaseAction<typeof REQ_FAILED>;

export type VIMEO_ACTION =
  | REQ_VIMEO_THUMBNAIL_TYPE
  | RCV_VIMEO_THUMBNAIL_TYPE
  | REQUEST_FAILED_TYPE;

type Dispatch = ReduxDispatch<VIMEO_ACTION>;

export const getThumbnail = (id: string) => async (dispatch: Dispatch) => {
  if (requestCache.isPending(`${REQ_VIMEO_THUMBNAIL}/${id}`)) {
    return;
  }

  requestCache.isPending(`${REQ_VIMEO_THUMBNAIL}/${id}`, true);

  try {
    dispatch({ type: REQ_VIMEO_THUMBNAIL, id });

    const response = await http.json<Vimeo>(`/api/vimeo/thumbnail/${id}`, buildGetRequest());
    http.validateResponse(response);
    dispatch({
      type: RCV_VIMEO_THUMBNAIL,
      response: response.response,
      id,
    });
  } catch (_e) {
    dispatch({ type: REQ_FAILED, action: REQ_VIMEO_THUMBNAIL });
  }
  requestCache.isPending(`${REQ_VIMEO_THUMBNAIL}/${id}`, false);
};
